import type { OrganizationEnvironmentKeySetsApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { OrganizationEnvironmentKeysetResponse } from '../../models/organizationEnvironment.model';

export function mapUpdateOrganizationEnvironmentKeySetsResponse(
  response: OrganizationEnvironmentKeySetsApi,
): OrganizationEnvironmentKeysetResponse {
  return response;
}
